<template>
    <v-app>
        <Sidebar
            v-if="loggedIn"
            :drawer="drawer"
            @toggle-drawer="toggleDrawer"
        />
        <Toolbar
            :drawer="drawer"
            :main-loader="mainLoader"
            @open-change-password-dialog="openChangePasswordDialog"
            @toggle-drawer="toggleDrawer"
        />
        <Content />
        <Footer />

        <Snackbar />

        <v-overlay :value="circularLoader" color="black" opacity="0.2" z-index="500">
            <v-progress-circular
                indeterminate
                color="secondary"
                size="64"
                width="3"
            />
        </v-overlay>


        <v-overlay :value="mainLoader" color="black" opacity="0" z-index="500" />

        <ChangePasswordDialog
            :is-open="changePasswordDialog"
            @on-close="closeChangePasswordDialog"
        />

        <ReleaseNotesDialog
            :is-open="releaseNotesDialogOpen"
            :latest-version="latestVersionData"
            @on-close="closeReleaseNotesDialog"
        />
    </v-app>
</template>

<script>
import Toolbar from '@/components/Toolbar'
import Sidebar from '@/components/Sidebar'
import Content from '@/components/Content'
import Footer from '@/components/Footer'
import Snackbar from '@/components/Snackbar'
import ChangePasswordDialog from '@/views/User/ChangePasswordDialog'
import ReleaseNotesDialog from '@/components/ReleaseNotesDialog'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'App',
    components: {
        Toolbar,
        Sidebar,
        Content,
        Footer,
        Snackbar,
        ChangePasswordDialog,
        ReleaseNotesDialog
    },
    data() {
        return {
            drawer: true,
            changePasswordDialog: false,
        }
    },
    computed: {
        mainLoader() {
            return this.$store.state.common.mainLoader
        },
        circularLoader() {
            return this.$store.state.common.circularLoader
        },
        loggedIn() {
            return this.$store.getters.loggedIn
        },
        releaseNotesDialogOpen() {
            return this.$store.state.releaseNotes.showDialog
        },
        latestVersionData() {
            return this.$store.state.releaseNotes.latestVersionData
        },
        user() {
            return this.$store.state.user.user
        },
        isLastSystemVersionRead() {
            return this.$store.getters.isLastSystemVersionRead
        }
    },
    watch: {
        loggedIn(newVal) {
            if (newVal) {
                this.$store.dispatch('getUser', this.$store.state.user.userId)
                    .catch(error => {
                        errorHandler(error)
                    })
            }
        },
        user(newVal) {
            if (newVal && !this.isLastSystemVersionRead) {
                this.$store.dispatch('releaseNotes/fetchLatestVersion')
                    .then(() => {
                        this.$store.commit('releaseNotes/SET_SHOW_DIALOG', true)
                    })
                    .catch(error => {
                        errorHandler(error)
                    })
            }
        }
    },
    mounted() {
        this.$store.dispatch('getErrorCodes')
            .catch(error => {
                errorHandler(error)
            })

        if (this.loggedIn && !this.$store.state.user.user) {
            this.$store.dispatch('getUser', this.$store.state.user.userId)
                .catch(error => {
                    errorHandler(error)
                })
        }
    },
    methods: {
        toggleDrawer(value) {
            this.drawer = value
        },
        openChangePasswordDialog() {
            this.changePasswordDialog = true
        },
        closeChangePasswordDialog() {
            this.changePasswordDialog = false
        },
        closeReleaseNotesDialog() {
            this.$store.commit('releaseNotes/SET_SHOW_DIALOG', false)
        }
    }
}
</script>
